import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import LoginScreen from "./pages/LoginScreen";
import RegisterScreen from "./pages/RegisterScreen";
import HomeScreen from "./pages/HomeScreen";
import RoomDetailScreen from "./pages/RoomDetailScreen";
import RoomManageScreen from "./pages/RoomManageScreen";
import MessageScreen from "./pages/MessageScreen";
import StatisticsScreen from "./pages/StatisticsScreen";
import AdminDashboard from "./pages/AdminDashboard";
import SubAccountScreen from "./pages/SubAccountScreen";
import MyResidenceScreen from "./pages/MyResidenceScreen";
import MainLayout from "./components/MainLayout";
import WorkOrderScreen from "./pages/WorkOrderScreen";
import ProfileScreen from "./pages/ProfileScreen";
import LegalScreen from "./pages/LegalScreen";

const readSavedUser = () => {
    try {
        const saved = JSON.parse(localStorage.getItem("user") || "null");
        if (saved && typeof saved === "object" && !Array.isArray(saved) && typeof saved.role === "string") return saved;
    } catch (error) {
        // Recover from invalid cached sessions.
    }
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    return null;
};

const PrivateRoute = ({ children }) => {
    const token = localStorage.getItem("token");
    return token ? children : <Navigate to="/login" replace />;
};

const AdminRoute = ({ children }) => {
    const token = localStorage.getItem("token");
    const user = readSavedUser();
    if (!token) return <Navigate to="/login" />;
    if (user?.role !== "admin") return <Navigate to="/" replace />;
    return children;
};

function App() {
    const [user, setUser] = useState(readSavedUser);

    return (
        <ConfigProvider locale={zhCN}>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<LoginScreen setUser={setUser} />} />
                    <Route path="/register" element={<RegisterScreen />} />
                    <Route path="/agreement" element={<LegalScreen type="agreement" />} />
                    <Route path="/privacy" element={<LegalScreen type="privacy" />} />
                    <Route path="/" element={<PrivateRoute><MainLayout user={user}><HomeScreen /></MainLayout></PrivateRoute>} />
                    <Route path="/room/:id" element={<PrivateRoute><MainLayout user={user}><RoomDetailScreen /></MainLayout></PrivateRoute>} />
                    <Route path="/manage" element={<PrivateRoute><MainLayout user={user}><RoomManageScreen /></MainLayout></PrivateRoute>} />
                    <Route path="/my-residence" element={<PrivateRoute><MainLayout user={user}><MyResidenceScreen /></MainLayout></PrivateRoute>} />
                    <Route path="/messages" element={<PrivateRoute><MainLayout user={user}><MessageScreen /></MainLayout></PrivateRoute>} />
                    <Route path="/work-orders" element={<PrivateRoute><MainLayout user={user}><WorkOrderScreen user={user} /></MainLayout></PrivateRoute>} />
                    <Route path="/profile" element={<PrivateRoute><MainLayout user={user}><ProfileScreen user={user} /></MainLayout></PrivateRoute>} />
                    <Route path="/statistics" element={<PrivateRoute><MainLayout user={user}><StatisticsScreen /></MainLayout></PrivateRoute>} />
                    <Route path="/sub-accounts" element={<PrivateRoute><MainLayout user={user}><SubAccountScreen /></MainLayout></PrivateRoute>} />
                    <Route path="/admin/*" element={<AdminRoute><MainLayout user={{...user, role: "admin"}}><AdminDashboard /></MainLayout></AdminRoute>} />
                    <Route path="*" element={<Navigate to={localStorage.getItem("token") ? "/" : "/login"} replace />} />
                </Routes>
            </BrowserRouter>
        </ConfigProvider>
    );
}

export default App;
